export const PRESCRYPTION_TYPE = {
	WP: 'Producto con receta', //Productos de presentación de receta
	APR: 'Producto con receta', //Productos de presentación de receta antimicrobianos
	MRE: 'Producto con receta', //Productos de presentación de receta que contengan algun psicotrópico
	RMRSCS: 'Producto con receta', //Procutos de receta médica retenida sin control de stock
	RMRCCS: 'Producto con receta', //Productos de receta retenida con control de stock,
	NP: 'Producto sin receta',
};
